import { render, staticRenderFns } from "./FundraisingGoalDonations.vue?vue&type=template&id=96707564&scoped=true&"
import script from "./FundraisingGoalDonations.vue?vue&type=script&lang=ts&"
export * from "./FundraisingGoalDonations.vue?vue&type=script&lang=ts&"
import style0 from "./FundraisingGoalDonations.vue?vue&type=style&index=0&id=96707564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96707564",
  null
  
)

export default component.exports